import { render, staticRenderFns } from "./UpdateActionItems.vue?vue&type=template&id=3a66ffca&scoped=true&"
import script from "./UpdateActionItems.vue?vue&type=script&lang=ts&"
export * from "./UpdateActionItems.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateActionItems.vue?vue&type=style&index=0&id=3a66ffca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a66ffca",
  null
  
)

export default component.exports